
<template>
  <div>
    <header>
      <p v-on:click="backHistory"  >
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">邀请投递</span>
      </p>
      <!--<p>-->

      <!--</p>-->
    </header>
    <div style="margin-top: 70px">

      <!--内容 1-->
          <div class="messageCenter" v-for="(index,key) in list" >
            <div class="positionS">
              <div>
                <span></span>
                <span>{{index.name}}</span>
                <span class="positionSpan">普通职位</span>
              </div>
              <div style="padding-top: 0.5rem">
                <span class="positionSpan1">{{index.city}}</span>
                <span class="positionSpan1" v-if="index.work_year==1">不限</span>
                <span class="positionSpan1" v-else-if="index.work_year==2" >/1年以下</span>
                <span class="positionSpan1" v-else-if="index.work_year==3" >/1-3年</span>
                <span class="positionSpan1" v-else-if="index.work_year==4" >/3-5年</span>
                <span class="positionSpan1" v-else-if="index.work_year==5" >/5-10年</span>
                <span class="positionSpan1" v-else-if="index.work_year==6" >/10年以上</span>
                <span class="positionSpan1" v-if="index.edu==1" >/不限</span>
                <span class="positionSpan1" v-else-if="index.edu==2"  >/大专</span>
                <span class="positionSpan1" v-else-if="index.edu==3" >/本科</span>
                <span class="positionSpan1" v-else-if="index.edu==4" >/硕士</span>
                <span class="positionSpan1" v-else-if="index.edu==5" >/博士</span>
              </div>
              <!--1:不限 2：大专 3：本科 4：硕士 5：博士)-->
            </div>
            <div class="positionH">
              <span style="color: #00b38a">
                <!--<van-checkbox-group v-model="result" ref="checkboxGroup" >-->
                     <!--<van-checkbox :name=key @click="toggle(index)">复选框 a</van-checkbox>-->
                <!--</van-checkbox-group>-->
          <van-checkbox-group v-model="result">
           <van-cell-group>
             <van-cell
               @click="toggle(index)"
             >
               <template #right-icon>
                 <van-checkbox :name=key @click="toggle(index)" />
               </template>
             </van-cell>
           </van-cell-group>
         </van-checkbox-group>

              </span>
              <span></span>
            </div>
          </div>
      <van-button style="float: right" size="small" plain type="primary" @click="save">邀请投递</van-button>

    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        招人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 'a',
//        active:0,
        list:{},
        name:'',
        uploadImages:[],
//        checked:true,
        arr:{},
        result: [],
        checked:''
      }
    },
    mounted(){
      this.getComPositioner()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toggle(index) {
        this.arr=index
      },
//      toDetailPosition(id){
//        this.$router.push({
//          path:`/comDetailsPosition/${id}`
//        })
//      },
      getComPositioner(){
        this.$api.getComPosition({
          "user_id":localStorage.getItem("userid"),
//          "id":this.$route.params.id
        })
          .then(res=>{
            if(res.status==200){
              this.list=res.data
            }
         })
          .catch(res=>{
       })
      },
      save(){
        console.log(this.result.length)
        if(this.result.length==0) return this.$toast("请选择职位")
//        if()
         this.$api.invitationPost({
           "job_id":this.arr.id,
           "user_id":this.arr.user_id,
           "company_id":this.arr.company_id
          })
           .then(res=>{
//             if(res.stat)
             this.$router.push({
               path:"/comTalentsDtails",
               query:{
                 id:this.$route.query.id
               }
             })
             this.$toast(res.data)
           })
      },

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/

    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  header p{
    padding-left: 1rem;
    display: flex;
  }
  .messageCenter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*padding: 0px 1rem;*/
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    border-bottom: solid 1px #DEDEDE;
  }
  .positionSpan{
    font-size: 12px;
    background: #dce6f0;
    color: #44B389;
    padding: 2px 2px;
    border-radius: 8px;
  }
  .positionSpan1{
    /*display: flex;*/
    padding-top: 8px;
    font-size: 13px;
    color: grey;
  }
  .positionH{
    font-size: 15px;
  }
  .positionH span{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/invitationPost.vue